<script>
    export let company_data;
    
    let whatsapp_url = company_data.whatsapp.url;
</script>

<style>
    .whatsapp-widget {
        position: fixed;
        width: 60px;
        height: 60px;
        bottom: 40px;
        right: 40px;
        background-color: #25d366;
        color: #fff;
        border-radius: 50px;
        text-align: center;
        font-size: 30px;
        box-shadow: 1px 1px 2px #888;
        z-index: 1000;
    }
</style>

<main>
    <a
        class="whatsapp-widget"
        href="{whatsapp_url}"
        target="_blank">
        <i style="margin-top:16px" class="fa fa-whatsapp" />
    </a>
</main>
